export default function upperFirstLetter(text: string): string {
  if (!text) return '';
  const string = text.toLowerCase();
  return string[0].toUpperCase() + string.slice(1);
}
